import SEO, { type Crumb } from '@/components/SEO';
import PageHeader from '@/components/PageHeader';
import { staticPage } from '@/lib/content';
import { EMAIL } from '@/lib/site';

const Accessibility = () => {
  const page = staticPage('/accessibility');
  const crumbs: Crumb[] = [
    { name: 'Home', href: '/' },
    { name: 'Accessibility', href: '/accessibility' },
  ];
  return (
    <>
      <SEO title={page.title} description={page.description} path="/accessibility" breadcrumbs={crumbs} />
      <PageHeader crumbs={crumbs} label="Accessibility" title="Accessibility" lead="This site is meant to be usable by everyone who runs a WebCenter estate. Here is what that means in practice, and how to tell us when it falls short." />
      <section className="container py-14 md:py-16">
        <div className="prose max-w-[46rem]">
          <h2>The standard</h2>
          <p>
            WCAG 2.2 Level AA guides our accessibility work. We have not completed an independent conformance
            assessment of the whole site, so this page describes the features and limitations we currently know.
          </p>
          <h2>What is in place</h2>
          <ul>
            <li>Page headings and landmarks for navigation, main content and the footer.</li>
            <li>Static articles and page information are included in the HTML delivered by the server.</li>
            <li>Native links, buttons and labeled form controls, with visible keyboard focus.</li>
            <li>A skip link to the main content at the top of every page.</li>
            <li>Text scales with browser settings; layouts reflow to a single column on narrow screens.</li>
            <li>Decorative illustrations are hidden from assistive technology; diagrams have accompanying text.</li>
            <li>Reduced-motion preferences are respected.</li>
          </ul>
          <h2>Known limitations</h2>
          <p>
            Interactive tools, search, diagram controls and online form submission require JavaScript. The contact
            form stays disabled until it is ready, with an email link available as an alternative. Some wide data
            tables scroll horizontally. A complete screen-reader, zoom and cross-browser review remains to be done.
          </p>
          <h2>Tell us</h2>
          <p>
            Email <a href={`mailto:${EMAIL}`}>{EMAIL}</a>. Include the page, what you were trying to do and what
            happened. If you need information in another format, tell us what would help.
          </p>
          <p>Last reviewed September 16, 2026.</p>
        </div>
      </section>
    </>
  );
};

export default Accessibility;
